import { renderRichText } from 'gatsby-source-contentful/rich-text'
import { INLINES, Hyperlink } from '@contentful/rich-text-types'
import React from 'react'

const rewriteYouTubeUri = (uri: string): string => {
  const embedPattern = /\/embed\//

  if (embedPattern.test(uri)) {
    return uri
  } else {
    if (uri.includes('youtu.be')) {
      return uri.replace(/youtu.be\/([\w-]+)/, 'www.youtube.com/embed/$1')
    } else {
      return uri.replace(
        /youtube.com\/watch\?v=([\w-]+).*$/,
        'www.youtube.com/embed/$1',
      )
    }
  }
}

const isYouTubeUri = (uri: string): boolean => {
  const youtubePattern = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)/

  return youtubePattern.test(uri)
}

const richTextOptions = {
  renderNode: {
    [INLINES.ASSET_HYPERLINK]: (node: any, children: any) => {
      console.log('node', node)
      return (
        <a href={node.data.target.url} target="_blank" download>
          {children}
        </a>
      )
    },
    [INLINES.HYPERLINK]: (node: any, children: any) => {
      const { uri } = node.data
      if (isYouTubeUri(uri)) {
        return (
          <iframe
            src={rewriteYouTubeUri(uri)}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="mx-auto w-full"
            style={{ aspectRatio: '16/9' }}
          ></iframe>
        )
      } else {
        return <a href={uri}>{children}</a>
      }
    },
  },
}

interface richTextData {
  raw: string
  references: [
    {
      contentful_id: string
      __typename: string
      url: string
    },
  ]
}
const renderContentfulRichText = (richText: {
  readonly raw: string | null
  readonly references:
    | [
        {
          contentful_id: string
          __typename: string
          url: string
        },
      ]
    | null
}) => {
  if (richText.raw !== null && richText.references !== null) {
    const data: richTextData = {
      raw: richText.raw,
      references: richText.references,
    }

    return renderRichText(data, richTextOptions)
  } else {
    return ''
  }
}

export default renderContentfulRichText
